// src/context/FBRDataContext.js
import React, { createContext, useState, useEffect } from "react";
import { supabase } from "../supabaseClient";

export const FBRDataContext = createContext({
  recordCount: 0,
});

export const FBRDataProvider = ({ children }) => {
  const [recordCount, setRecordCount] = useState(0);

  useEffect(() => {
    supabase
      .from(process.env.REACT_APP_DB)
      .select("*", { count: "exact", head: true })
      .then(({ count, error }) => {
        if (!error && count !== null) setRecordCount(count);
        else if (error)
          console.error("Failed to fetch FBR record count:", error);
      });
  }, []);

  return (
    <FBRDataContext.Provider value={{ recordCount }}>
      {children}
    </FBRDataContext.Provider>
  );
};
